import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cockpit-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_8 = {
  key: 1,
  class: "empty"
}

import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { toast } from "@/common/utils/toast";
import store from "@/store";

import {
  evaluationList,
  evaluationListByMember,
} from "@/common/api/rest/evaluation";

import type { EvaluationListType } from "@/common/types/evaluation";

import { PanelTheme } from "@/common/themes";

import {
  baseLoading,
  baseInput,
  baseSelect,
  cardEvaluation,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const listRef = ref();
const searchInput = ref("");

const evaluations = ref<EvaluationListType[]>([]);
const statusType = ref("PROGRESS");

const loading = ref(false);
const hasScroll = ref(false);

const accountId = computed(() => route.params.id as string);
const userId = computed(() => store.getters.user?.member_id as string);
const userType = computed(() => store.getters.type as string);

const statusOptions = computed(() => [
  {
    option: t("evaluation.labels.in_progress"),
    value: "PROGRESS",
  },
  {
    option: t("evaluation.labels.started"),
    value: "STARTED",
  },
  {
    option: t("evaluation.labels.pending"),
    value: "PENDING",
  },
  {
    option: t("evaluation.labels.concluded"),
    value: "CONCLUDED",
  },
  {
    option: t("evaluation.labels.canceled"),
    value: "CANCELED",
  },
]);

function checkScroll() {
  if (!listRef.value) return false;

  hasScroll.value = listRef.value?.scrollHeight > listRef.value?.clientHeight;
}

async function fetchEvaluationListAll() {
  loading.value = true;

  evaluationList(accountId.value, {
    page: 0,
    limit: 100,
    search: searchInput.value,
    full: true,
    status: statusType.value,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        evaluations.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
      checkScroll();
    });
}

async function fetchEvaluationListById() {
  loading.value = true;

  evaluationListByMember(accountId.value, userId.value, {
    page: 0,
    limit: 50,
    search: searchInput.value,
    all: true,
    status: statusType.value,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        evaluations.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
      checkScroll();
    });
}

function fetchData() {
  if (!accountId.value) return;

  switch (userType.value) {
    case "MANAGER":
    case "ADMIN":
      {
        fetchEvaluationListAll();
      }
      break;
    case "TECHNICAL":
    case "ASSISTANT":
      {
        fetchEvaluationListById();
      }
      break;
  }
}

function selectEvaluation(evaluation: EvaluationListType) {
  router.push(`/${accountId.value}/evaluate/${evaluation.evaluation_id}`);
}

function cleanSearch() {
  if (!searchInput.value) {
    fetchData();
  }
}

function searchValue() {
  fetchData();
}

function changeStatus() {
  localStorage.setItem("evaluation-status", statusType.value);

  fetchData();
}

watch(
  () => userType.value,
  () => {
    fetchData();
  }
);

onMounted(() => {
  const status = localStorage.getItem("evaluation-status");
  statusType.value = status || "PROGRESS";

  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(baseSelect), {
              modelValue: statusType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusType).value = $event)),
              value: statusType.value,
              options: statusOptions.value,
              "is-empty": false,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (changeStatus()))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(baseInput), {
              modelValue: searchInput.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((searchInput).value = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (cleanSearch()))
              ],
              placeholder: _unref(t)('common.labels.search'),
              background: "#fff",
              color: "#000",
              "onKey:enter": _cache[5] || (_cache[5] = ($event: any) => (searchValue()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (searchValue()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("section", {
          ref_key: "listRef",
          ref: listRef,
          class: _normalizeClass(["evaluations", { scrollable: hasScroll.value }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluations.value, (evaluation) => {
              return (_openBlock(), _createBlock(_unref(cardEvaluation), {
                key: evaluation.evaluation_id,
                evaluation: evaluation,
                onClick: ($event: any) => (selectEvaluation(evaluation))
              }, null, 8, ["evaluation", "onClick"]))
            }), 128))
          ]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(baseLoading))
              ]))
            : _createCommentVNode("", true),
          (!loading.value && evaluations.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("evaluation.texts.empty_evaluation")), 1))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})